export enum UserType {
	INTERNAL = "INTERNAL",
	EXTERNAL = "EXTERNAL",
}

export enum UserRole {
	SALES = "SALES",
	DESIGNER = "DESIGNER",
	ADMIN = "ADMIN",
	ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
	ACCOUNT_USER = "ACCOUNT_USER",
}
